import styled from 'styled-components';

// Material-UI
import MenuItem from '@material-ui/core/MenuItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

// *************************************
// STYLED COMPONENTS                           
// *************************************

// Menu Item
export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    min-height: 50px;
    padding: 0 16px;
    white-space: normal;
    color: ${(props) => props.theme.colors.greyDark};
    &:hover {
      background-color: ${(props) => props.theme.colors.greyHover};
    }
  }
`;

// Menu Header
export const StyledMenuHeader = styled(ListSubheader)`
  &.MuiListSubheader-root { 
    height: 50px;
    padding: 0 16px;
    white-space: normal;
    color: ${(props) => props.theme.colors.greyDark};
    background-color: ${(props) => props.theme.colors.white};
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};
  }
`;

// List
export const StyledList = styled(List)`
  &.MuiList-padding {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

// List Item
export const StyledListItem = styled(ListItem)`
  &.MuiListItem-root {
    min-height: 40px;
    padding: 0px 32px 0 16px;
  }

  & > a {
    text-decoration: none;
  }
`;

// List Item Icon
export const StyledListItemIcon = styled(ListItemIcon)`
  &.MuiListItemIcon-root {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    margin-right: 12px;
    color: ${(props) => props.theme.colors.greyDark};
  }

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;